// feedbackApi — submits thumbs feedback for an assistant message run.
// Calls POST /api/v1/feedback via the shared/api client singleton.

import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import type { FeedbackValue } from '../model/types';

function getClient() {
  return createApiClient({
    baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
    auth: { getToken },
  });
}

export async function submitFeedback(
  runId: string,
  value: FeedbackValue,
  comment?: string,
): Promise<void> {
  const rating = value === 'up' ? 1 : 0;
  await getClient().request({
    method: 'POST',
    path: '/api/v1/feedback',
    body: {
      run_id: runId,
      rating,
      feedback_text: comment ?? '',
    },
  });
}
